import * as React from 'react';
export const speiSvg = React.forwardRef(function speiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'm0 8.818 1.473-.09c.032.232.097.408.195.529.16.195.388.293.684.293.22 0 .39-.05.51-.148a.447.447 0 0 0 .18-.35.438.438 0 0 0-.17-.336c-.115-.1-.379-.193-.794-.28C1.4 8.287.915 8.091.626 7.847a1.164 1.164 0 0 1-.438-.933c0-.249.074-.483.222-.703.15-.222.375-.395.674-.52.3-.128.712-.192 1.234-.192.64 0 1.128.115 1.463.346.337.229.537.594.601 1.095l-1.46.083c-.038-.218-.12-.376-.245-.475-.124-.1-.294-.149-.513-.149-.18 0-.316.038-.407.113a.33.33 0 0 0-.137.267c0 .077.038.146.113.207.073.064.246.124.52.179.676.14 1.16.283 1.452.428.294.143.507.321.64.535.134.213.201.451.201.715 0 .31-.089.596-.266.858-.178.261-.426.46-.745.597-.32.134-.722.201-1.207.201-.852 0-1.443-.158-1.77-.475C.228 9.708.042 9.306 0 8.818Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.969 5.582h2.574c.56 0 .98.13 1.258.386.28.258.42.624.42 1.099 0 .488-.153.87-.458 1.144-.303.275-.767.412-1.391.412h-.848v1.795H4.969V5.582Zm1.555 2.062h.38c.298 0 .508-.05.628-.149a.481.481 0 0 0 .182-.386.527.527 0 0 0-.158-.385c-.104-.106-.302-.159-.591-.159h-.441v1.079Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 5.582h-1.552v1.685h.586V6.262L16 7.6V5.582Zm0 2.32-.966 1.338V8.234h-.586v2.184H16V7.902Zm-6.322-2.32h4.15v.961H11.23v.73h2.41v.974h-2.41v1.076h2.673v1.095H9.678V5.582Z',
    }),
  );
});
speiSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var spei = {
  category: 'paymentmethod',
  colorable: true,
  name: 'spei',
  svg: speiSvg,
};
